export default __webpack_public_path__ + "static/media/lic1.f93914e7.svg";